var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFpt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66013_52687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97037 3.39186C10.3564 3.39186 10.6693 3.07895 10.6693 2.69297C10.6693 2.32242 10.3689 2.02203 9.99832 2.02203H9.32913V1.87949C9.32913 1.40239 8.94237 1.01562 8.46527 1.01562H7.50926C7.03216 1.01562 6.64539 1.40239 6.64539 1.87949V2.02203H5.74906C5.37851 2.02203 5.07812 2.32242 5.07812 2.69297C5.07812 3.07895 5.39103 3.39186 5.77702 3.39186H9.97037Z",
    stroke: "black",
    strokeWidth: 1.25123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07031 1.69531C5.41568 1.69549 5.69531 1.97588 5.69531 2.32129C5.69531 2.6667 5.41568 2.94709 5.07031 2.94727H3.67188C3.4672 2.94735 3.27071 3.02812 3.12598 3.17285C2.98124 3.31758 2.90048 3.51407 2.90039 3.71875V13.5039C2.90048 13.7086 2.98125 13.9051 3.12598 14.0498C3.27071 14.1945 3.46721 14.2753 3.67188 14.2754H12.0586C12.2632 14.2754 12.4597 14.1944 12.6045 14.0498C12.7492 13.9051 12.831 13.7086 12.8311 13.5039V3.71875C12.831 3.51408 12.7492 3.31758 12.6045 3.17285C12.4597 3.02824 12.2632 2.94727 12.0586 2.94727H10.6611C10.3156 2.94727 10.0352 2.66681 10.0352 2.32129C10.0352 1.97577 10.3156 1.69531 10.6611 1.69531H12.0586C12.5951 1.69531 13.1098 1.90882 13.4893 2.28809C13.8686 2.66747 14.0819 3.18223 14.082 3.71875V13.5039C14.0819 14.0404 13.8686 14.5552 13.4893 14.9346C13.1098 15.3138 12.5951 15.5273 12.0586 15.5273H3.67188C3.13536 15.5273 2.62059 15.3139 2.24121 14.9346C1.86183 14.5552 1.64853 14.0404 1.64844 13.5039V3.71875C1.64852 3.18223 1.86183 2.66747 2.24121 2.28809C2.6206 1.9087 3.13535 1.6954 3.67188 1.69531H5.07031Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2909 6.85938L6.86289 10.2874L5.30469 8.72921",
    stroke: "black",
    strokeWidth: 1.25123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66013_52687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9747,
    height: 15.9747,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpt);
export default __webpack_public_path__ + "static/media/fpt.62fbd0af590b43afefed3a74bec827ff.svg";
export { ForwardRef as ReactComponent };